export default __webpack_public_path__ + "static/media/menu_TC_logo.b92de73f.svg";